import { useAppSettings } from "../context/AppSettingsContext";
import { useWindowWidth } from "./useWindowWidth";
import { Sizes } from "../constants";
import { useMemo } from "react";

export function useMobileStyles() {
  const { settings } = useAppSettings();
  const windowWidth = useWindowWidth();
  const isMobile = typeof windowWidth === "number" && windowWidth <= Sizes.BREAKPOINT_MOBILE;

  const colorStyle = useMemo(() => {
    const color = settings?.textColor;
    return isMobile && typeof color === "string" && color.trim() !== ""
      ? { color }
      : '';
  }, [isMobile, settings?.textColor]);

  const bgColorStyle = useMemo(() => {
    const bgColor = settings?.bgColor;
    return isMobile && typeof bgColor === "string" && bgColor.trim() !== ""
      ? { backgroundColor: bgColor }
      : '';
  }, [isMobile, settings?.bgColor]);

  return { isMobile, colorStyle, bgColorStyle, settings, windowWidth };
}